<template>
  <a-layout class='index animated fadeIn'>
    <a-card :bordered='false'>
      <SmallSquare class='m-b-25' content='单独设置门店或经销商的订货折扣率模板，生成模板后需在下级门店/下级经销商中配置；没有配置的按整体订货设置中所在等级折扣率进行兑换' />
      <div class='mb25 s_flex_ali'>
        <span class='mr15'>
          <a-button type="primary" v-has:onlinePriceTemplateCreate="()=> {$router.push({path:'/onlineOrder/orderPriceTemplate/create',query:{type:'add',date:new Date().getTime()}})}">
            <PlusOutlined />
            新增模板
          </a-button>
        </span>
      </div>
      <a-table :pagination='false' :loading='listLoading' bordered rowKey='id' :columns='columns' :data-source='list'>
        <template v-slot:product_name="{record}">
          <a-card-meta>
            <template #avatar>
              <img :src="info.picdomain+'/'+(record.product_image||record.cover_image_url)" alt="" style="width:50px;height: 50px;object-fit:cover">
            </template>
            <template #description>{{record.product_name}}</template>
          </a-card-meta>
        </template>
        <template v-slot:action="{ record }">
          <a-button class="m-r-5" type="primary" v-has:onlinePriceTemplateEdit="()=>$router.push({path:'/onlineOrder/orderPriceTemplate/edit?id',query:{id:record.id,type:'edit'}})">修改</a-button>
          <a-button class="m-r-5" type="primary" v-has:onlinePriceTemplateEditGood="()=>editGoods(record)">修改特殊商品</a-button>
          <a-button class="m-r-5" danger v-has:onlinePriceTemplateDel="()=>del(record)">删除</a-button>
        </template>
      </a-table>
      <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `" />
    </a-card>
    <a-modal :title="specialGoodsData.tem_name" :maskClosable="false" centered v-model:visible="goodsVisible" :footer="null" :width="1000">
      <editGoodsCompoents :options="specialGoodsData" />
    </a-modal>
  </a-layout>
</template>
<script>
import { PlusOutlined } from "@ant-design/icons-vue";
import { ref, onMounted, inject, reactive, toRefs } from "vue";
import { message } from "ant-design-vue";

import editGoodsCompoents from "./editGoodsCompoents.vue";
import { priceTem, delPriceTem } from "@/api/online";
import { iscode } from "@/utils/app";
import store from "@/store";
import useTableSearch from "@/hooks/useTableSearch";
// 初始化默认筛选项数值
let defSearch = {
  page: 1,
  limit: 10,
  product_name: "",
};
export default {
  components: {
    PlusOutlined,
    editGoodsCompoents,
  },
  setup(props, ctx) {
    let columns = [
      {
        title: "模板名称",
        dataIndex: "tem_name",
        key: "tem_name",
      },
      {
        title: "折扣率",
        dataIndex: "discount_rate",
        key: "discount_rate",
      },
      {
        title: "备注",
        dataIndex: "remark",
        key: "remark",
      },
      {
        title: "创建时间",
        dataIndex: "created_at",
        key: "created_at",
      },
      {
        title: "操作",
        key: "action",
        slots: { customRender: "action" },
      },
    ];
    const $Modal = inject("$Modal");
    const {
      pageCurrentChange,
      pageSizeChange,
      search,
      list,
      initData,
      total,
      listLoading,
    } = useTableSearch({ data: defSearch });
    const tableHoosks = {
      pageCurrentChange,
      pageSizeChange,
      search,
      initData,
      list,
      total,
      listLoading,
    };
    onMounted(() => {
      tableHoosks.initData(priceTem, search.value);
    });
    const del = (e) => {
      $Modal.confirm({
        centered: true,
        title: "确定删除模板？",
        content: `删除模板后，关联模板的门店/经销商变回所在等级折扣率`,
        onOk: async () => {
          let res = await delPriceTem(e.id).then((res) => res.data);
          if (iscode(res)) {
            tableHoosks.initData(priceTem);
            $Modal.destroyAll();
          }
        },
      });
    };
    const form = ref();

    const specialGoods = () => {
      const goodsVisible = ref(false);
      const specialGoodsData = ref({});
      const editGoods = (data) => {
        specialGoodsData.value = data;
        goodsVisible.value = true;
      };
      const specialGoodsSuccess = () => {
        tableHoosks.initData(priceTem);
      };
      return {
        specialGoodsData,
        goodsVisible,
        editGoods,
        specialGoodsSuccess,
      };
    };
    const { goodsVisible, editGoods, specialGoodsSuccess, specialGoodsData } =
      specialGoods();
    return {
      info: store.state.user.info,
      ...tableHoosks,
      columns,
      form,
      del,
      goodsVisible,
      editGoods,
      specialGoodsSuccess,
      specialGoodsData,
    };
  },
};
</script>